import { menuIcons } from "./icons"
export type T分類 = {
  分類名: string
  分類コード: Tメニュー分類コード
  url: string
  icon: keyof typeof menuIcons
}
/**
 * 大分類のコード値一覧
 */
export const メニュー分類 = {
  トップ: "01",
  受注配車: "02",
  海コン受注配車: "03",
  運行管理: "04",
  請求_支払管理: "05",
  購買管理: "06",
  乗務員管理: "07",
  車輌管理: "08",
  勤怠管理: "09",
  経営管理: "10",
  給与管理: "13",
  マスタ管理: "11",
  Ayanas_Query: "90",
} as const

export type Tメニュー分類プロパティ名称 = keyof typeof メニュー分類
export type Tメニュー分類コード =
  typeof メニュー分類[Tメニュー分類プロパティ名称]

export const 分類リスト: T分類[] = [
  {
    分類名: "トップ",
    分類コード: メニュー分類.トップ,
    url: "/top",
    icon: "DashboardIcon",
  },
  {
    分類名: "受注配車",
    分類コード: メニュー分類.受注配車,
    url: "/order",
    icon: "Order",
  },
  {
    分類名: "海コン受注配車",
    分類コード: メニュー分類.海コン受注配車,
    url: "/ordercontainer",
    icon: "Container",
  },
  {
    分類名: "運行管理",
    分類コード: メニュー分類.運行管理,
    url: "/trackcontrol",
    icon: "LocalShipping",
  },
  {
    分類名: "請求・支払管理",
    分類コード: メニュー分類.請求_支払管理,
    url: "/billing",
    icon: "RequestQuote",
  },
  {
    分類名: "購買管理",
    分類コード: メニュー分類.購買管理,
    url: "/purchase",
    icon: "ShoppingCart",
  },
  {
    分類名: "乗務員管理",
    分類コード: メニュー分類.乗務員管理,
    url: "/driver",
    icon: "Person",
  },
  {
    分類名: "車輌管理",
    分類コード: メニュー分類.車輌管理,
    url: "/truck",
    icon: "LocalShipping",
  },
  {
    分類名: "勤怠管理",
    分類コード: メニュー分類.勤怠管理,
    url: "/attendance",
    icon: "CalendarMonth",
  },
  {
    分類名: "経営管理",
    分類コード: メニュー分類.経営管理,
    url: "/budget",
    icon: "LeaderBoard",
  },
  {
    分類名: "給与管理",
    分類コード: メニュー分類.給与管理,
    url: "/driverpayroll",
    icon: "Payments",
  },
  {
    分類名: "マスタ管理",
    分類コード: メニュー分類.マスタ管理,
    url: "/master",
    icon: "Maintenance",
  },
  {
    分類名: "Ayanas Query",
    分類コード: メニュー分類.Ayanas_Query,
    url: "/ayanasquery",
    icon: "Storage",
  },
]
